import type { ObjectValues } from '@repo/common';

export const FaceCaptureStep = {
  CAPTURE_SELFIE: 'CAPTURE_SELFIE',
  PROCESSING: 'PROCESSING',
} as const;

export type FaceCaptureStepValues = ObjectValues<typeof FaceCaptureStep>;
